import { mainStore } from "../../store"
import { useState } from "react";

import { __ } from "../../utils";



export default function Interface({ visible = false }) {
    const [hovered, setHovered] = useState(false);
    const [hoveredChapter, setHoveredChapter] = useState(false);



    // Store
    const isUiHidden = mainStore.useStore(s => s.isUiHidden)
    const currentChapter = mainStore.useStore(s => s.current.chapter)
    const currentDates = mainStore.useStore(s => s.current.dates)
    const chapters = mainStore.useStore(s => s.chapters)
    const lang = mainStore.useStore(s => s.lang)

    const dynamicLangKey = lang === 'fr' ? 'fr' : 'en'
    // Style
    const uiMountedStyle = {
        position: 'absolute',
        zIndex: 999,
        top: 0,
        left: 0,
        pointerEvents: 'none',
        width: '100vw',
        height: '100vh',
    }

    const handleSelectChapter = (name, dates, start) => {
        mainStore.setChapterChangeRequested()
        mainStore.selectChapter(name, dates, start)
    }

    return <>


        <div className="interface" style={!isUiHidden ? { ...uiMountedStyle, opacity: 1 } : { ...uiMountedStyle, opacity: 0 }}>

            <a style={{ fontWeight: 100, fontFamily: 'Cormorant', fontSize: 18, color: "#333333", flexShrink: 0, position: "absolute",  bottom: '4vh', right: '2vw', pointerEvents: 'auto', userSelect: 'none' }} href="https://www.silab.fr/">silab.fr</a>
            {/* <a href="https://pmnd.rs/" style={{ position: 'absolute', bottom: 40, left: 90, fontSize: '13px' }}>
                pmnd.rs
                <br />
                dev collective
            </a>
            <div style={{ position: 'absolute', top: 40, left: 40, fontSize: '13px' }}>good —</div>
            <div style={{ position: 'absolute', bottom: 40, right: 40, fontSize: '13px' }}>10/15/2021</div> */}

            {/* <div style={{ position: 'absolute', top: '20vh', right: '3vw', rotate: '90deg', width: '60vh', height: 10, transform: 'translate(110%, -0%)', transformOrigin: 'right' }}>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>

                    <nav style={{ display: 'flex', gap: 12, listStyle: 'none' }}>
                        {
                            chapters.map(chapter => (
                                <li key={chapter.name}>
                                    <span style={{ display: 'block', opacity: .5, width: 8, height: 8, border: '.5px solid black', borderRadius: '50%', pointerEvents: 'auto', cursor: 'pointer' }}></span>

                                    <div style={{ position: 'fixed', width: '100%', rotate: '-90deg', top: 0, left: 0, height: '100%', display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                                        <span style={{ fontSize: '4rem', transformOrigin: 'right', transform: 'translateX(-5vw)', textAlign: 'right' }}>{chapter.name}</span>
                                    </div>
                                </li>
                            ))

                        }
                    </nav>

                </div>
            </div> */}

            <div className="sidebar"  style={{ position: 'absolute', top: '10vh', left: '10vw', rotate: '-90deg', width: '60vh', height: 10, paddingTop: '10vw', transform: 'translate(-110%, -50%)', transformOrigin: 'left', pointerEvents: 'auto', userSelect: 'none' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '2rem' }}>
                    <div style={{ flex: 1, position: 'relative', display: 'flex', alignContent: 'center', alignItems: 'center', textAlign: 'center', fontFamily: 'Montserrat', fontWeight: 300, letterSpacing: '.2rem', fontSize: 13 }}>
                        {/* <div style={{height: 1, flex: 1, width: '100%', justifyContent: 'space-around', borderBottom: 'black .5px dotted', opacity: 0.2 }}></div> */}
                        <span style={{ padding: '0 1rem', flexShrink: 0 }}>{ __('De', 'From') } {currentDates[0]} { __('à', 'to')} {currentDates[1] ?? 'Loading...'}</span>
                        <div className="dotted" style={{ position: 'relative', height: 1, flex: 1, width: '100%', justifyContent: 'space-around', borderBottom: 'black .5px dotted', opacity: 1, }}>

                            <div className="chapter-switch" style={{ position: 'absolute', top: '0', right: '50%', rotate: '0deg', width: '100%', height: 10, transition: 'all .5s ease', transform: 'translate(50%, 0)', transformOrigin: 'right' }}>
                                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>

                                    <nav style={{ display: 'flex', justifyContent: 'center', gap: 12, listStyle: 'none' }}>
                                        {
                                            chapters
                                            .slice(0)
                                            .reverse()
                                            .map((chapter, index) => (
                                                <li key={index}
                                                >
                                                    <span 
                                                        onClick={ () => handleSelectChapter(chapter.name[dynamicLangKey], chapter.dates, chapter.start) }
                                                        style={{ display: 'block', opacity: .5, width: 8, height: 8, border: '.5px solid', transition: 'all .5s ease', transitionDelay: (.2 * index) * 0.3  + 's' , borderRadius: '50%', pointerEvents: 'auto', cursor: 'pointer', background: (currentChapter === chapter.name[dynamicLangKey]) ? 'black': 'transparent', willChange: 'transform'}}></span>

                                                    <div className="chapter-title" style={{ position: 'fixed', width: '100%', rotate: '90deg', right:  (2 - (index * 1.8 * 0.8)) +'rem', top: '13vw', height: '100%', display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
                                                        <span style={{ fontSize: '4rem', transformOrigin: 'left',  textAlign: 'left', transition: 'all .2s ease', pointerEvents: 'none',textUnderlineOffset: '0.15em', textDecoration: (currentChapter === chapter.name[dynamicLangKey]) ? 'underline 2px': 'none',}}>{chapter.name[dynamicLangKey]}</span>
                                                    </div>
                                                </li>
                                            ))

                                        }
                                    </nav>

                                </div>
                            </div>

                        </div>
                    </div>
                    <div style={{ letterSpacing: '.4rem', fontWeight: 100, fontFamily: 'Cormorant', fontSize: 13, flexShrink: 0 }}>
                        {currentChapter}
                    </div>
                </div>
                {/* <div style={{height: 1, flex: 1, width: '100%', borderBottom: 'black .5px dotted', opacity: 0.2 }}></div> */}
            </div>

            

        </div>

    </>
}